import { Deserializable } from './deserializable';
import { UserPermissions } from './userPermissions';


export class UserPermissionsList implements Deserializable {
  permissions: UserPermissions[] = [];

  deserialize(input: any) {

    Object.assign(this, input);
    if (!input) {
      return this;
    }

    return this;
  }
}
